// noinspection NonAsciiCharacters
let packages = {
    osnovna : {
        5 : {
            "Trajni invaliditet " : "2.000,00 €",
            "Troškovi liječenja" : "962,50 €",
            "Dnevnu naknada" : "0,29 €",
            "Bolnički dan usled nezgode" : "0,44 € ",
            "Troškovi zbog smrti usljed nezgode" : "2.000,00 €",
            template : 1521600,
            product: "Vrtić i osnovci 5€"

        },
        6 : {
            "Trajni invaliditet " : "2.400,00 €",
            "Troškovi liječenja" : "1170,31 €",
            "Dnevnu naknada" : "0,34 €",
            "Bolnički dan usled nezgode" : "0,53 € ",
            "Troškovi zbog smrti usljed nezgode" : "2.400,00 €",
            template : 1521611,
            product: "Vrtić i osnovci 6€"

        },
        8 : {
            "Trajni invaliditet " : "3.200,00 €",
            "Troškovi liječenja" : "1.544,03 €",
            "Dnevnu naknada" : "0,46 €",
            "Bolnički dan usled nezgode" : "0,71 € ",
            "Troškovi zbog smrti usljed nezgode" : "3.200,00 €",
            template : 1521612,
            product: "Vrtić i osnovci 8€"

        },
        10 : {
            "Trajni invaliditet " : "4.000,00 €",
            "Troškovi liječenja" : "1.938,69 €",
            "Dnevnu naknada" : "0,57 €",
            "Bolnički dan usled nezgode" : "0,89 € ",
            "Troškovi zbog smrti usljed nezgode" : "4.000,00 €",
            template : 1521614,
            product: "Vrtić i osnovci 10€"

        },
        15 : {
            "Trajni invaliditet " : "6.000,00 €",
            "Troškovi liječenja" : "2.901,19 €",
            "Dnevnu naknada" : "0,86 €",
            "Bolnički dan usled nezgode" : "1,33 € ",
            "Troškovi zbog smrti usljed nezgode" : "6.000,00 €",
            template : 1521615,
            product: "Vrtić i osnovci 15€"

        },
    },
    srednja : {
        5 : {
            "Trajni invaliditet " : "2.250,00",
            "Troškovi liječenja" : "1.275,00 €",
            "Dnevnu naknada" : "0,30 €",
            "Bolnički dan usled nezgode" : "0,50 € ",
            "Smrt usled nesrećnog slučaja" : "2.250,00 €",
            template : 1499740,
            product: "Srednjoškolci i studenti 5€"


        },
        6 : {
            "Trajni invaliditet " : "2.700,00",
            "Troškovi liječenja" : "1.531,76 €",
            "Dnevnu naknada" : "0,36 €",
            "Bolnički dan usled nezgode" : "0,60 € ",
            "Smrt usled nesrećnog slučaja" : "2.700,00 €",
            template : 1499742,
            product: "Srednjoškolci i studenti 6€"


        },
        7 : {
            "Trajni invaliditet " : "3.150,00",
            "Troškovi liječenja" : "1.782,00 €",
            "Dnevnu naknada" : "0,42 €",
            "Bolnički dan usled nezgode" : "0,70 € ",
            "Smrt usled nesrećnog slučaja" : "3.150,00 €",
            template : 1499743,
            product: "Srednjoškolci i studenti 7€"


        },
        8 : {
            "Trajni invaliditet " : "3.600,00 €",
            "Troškovi liječenja" : "2.042,35 €",
            "Dnevnu naknada" : "0,48 €",
            "Bolnički dan usled nezgode" : "0,80 € ",
            "Smrt usled nesrećnog slučaja" : "3.600,00 €",
            template : 1499745,
            product: "Srednjoškolci i studenti 8€"


        },
        9 : {
            "Trajni invaliditet " : "4.050,00 €",
            "Troškovi liječenja" : "2.297,65 €",
            "Dnevnu naknada" : "0,54 €",
            "Bolnički dan usled nezgode" : "0,90 € ",
            "Smrt usled nesrećnog slučaja" : "4.050,00 €",
            template : 1499747,
            product: "Srednjoškolci i studenti 9€"


        },
        10 : {
            "Trajni invaliditet " : "4.500,00 €",
            "Troškovi liječenja" : "2.547,00 €",
            "Dnevnu naknada" : "0,60 €",
            "Bolnički dan usled nezgode" : "1,00 € ",
            "Smrt usled nesrećnog slučaja" : "4.500,00 €",
            template : 1499748,
            product: "Srednjoškolci i studenti 10€"

        },
        15 : {
            "Trajni invaliditet " : "6.750,00 €",
            "Troškovi liječenja" : "3.817,00 €",
            "Dnevnu naknada" : "0,90 €",
            "Bolnički dan usled nezgode" : "1,50 € ",
            "Smrt usled nesrećnog slučaja" : "6.750,00 €",
            template : 1499750,
            product: "Srednjoškolci i studenti 15€"

        },
    }
};

export default packages;